import { Catalog } from "../Catalog/Catalog";
import './Main.css'

export const Main = function(): JSX.Element {
    return (
        <main className="main">
            < Catalog />
        </main>
    )
}